import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MetalCutting.css';

const MetalCutting = () => {
    const [activeFaq, setActiveFaq] = useState(0);
    const navigate = useNavigate();
    const goToContact = () => navigate('/contact', { state: { scrollToForm: true } });

    const faqs = [
        {
            q: "What types of materials can you cut?",
            a: "We cut mild steel, stainless steel, aluminum, alloy steels, and other engineering metals."
        },
        {
            q: "Do you support bulk cutting orders?",
            a: "Yes, we handle both small custom orders and high-volume industrial cutting."
        },
        {
            q: "Can you provide custom size cutting?",
            a: "Yes, we cut materials according to exact drawing specifications."
        }
    ];

    return (
        <div className="metal-cutting-page">
            {/* Hero Section */}
            <section className="mc-hero">
                <div className="container">
                    <h1 className="fade-in">Precision Metal Cutting Services</h1>
                </div>
            </section>

            {/* About Section */}
            <section className="mc-about-section section-padding">
                <div className="container">

                    <div className="mc-about-header">
                        <div className="mc-about-title-group">
                            <div className="mc-icon-wrapper">
                                <img src="https://sakthivel.ascentbw.com/Files/About/About5.png" alt="Metal Cutting Icon" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/About/About1.png"; }} />
                            </div>
                            <h2>About Our Metal Cutting</h2>
                        </div>

                        <div className="mc-about-header-split">
                            <div className="mc-about-header-text">
                                <p>Sakthivel Engineering provides professional metal cutting services for a wide range of industrial applications. We deliver clean, accurate, and dimensionally precise cuts using advanced cutting equipment designed for both small-batch and large-scale production.</p>
                            </div>
                            <div className="mc-about-header-btn">
                                <button className="btn-primary" onClick={goToContact}>Request a Quote</button>
                            </div>
                        </div>
                    </div>

                    <div className="mc-capabilities-group">
                        <div className="mc-capability-block">
                            <h3>Our Metal Cutting Capabilities</h3>
                            <p>We offer reliable and high-precision cutting solutions tailored to engineering specifications and material requirements.</p>
                            <p className="mt-20">Our capabilities include:</p>
                            <ul className="mc-capabilities-list mt-10">
                                <li>• Profile Cutting</li>
                                <li>• Sheet & Plate Cutting</li>
                                <li>• Bar Cutting</li>
                                <li>• Structural Metal Cutting</li>
                                <li>• Custom Dimension Cutting</li>
                                <li>• Bulk Production Cutting</li>
                            </ul>
                        </div>

                        <div className="mc-capability-block mt-40">
                            <h3>Our Metal Cutting Services Include</h3>
                            <p>We provide customized cutting services to meet exact size, thickness, and finish requirements across industrial sectors.</p>
                        </div>
                    </div>

                    <div className="mc-about-img mt-40">
                        <img src="https://sakthivel.ascentbw.com/Files/Service/Sub5.png" alt="Metal Cutting Process" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/Service/Sub2.png"; }} />
                    </div>

                    <div className="mc-quality-block mt-40">
                        <h3>Quality & Process Control</h3>
                        <p className="mt-20">At Sakthivel Engineering, we maintain strict quality standards to ensure precise dimensions and clean finishes in every cutting operation.</p>
                        <ul className="mc-quality-list mt-20">
                            <li>Dimensional accuracy checks</li>
                            <li>Edge finish inspection</li>
                            <li>Material thickness verification</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Process Section */}
            <section className="mc-process-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-50">Our Metal Cutting Process</h2>

                    <div className="process-grid">
                        <div className="process-card">
                            <div className="process-num">01</div>
                            <h5 className="process-accent">Requirement Review</h5>
                            <h4>Requirement<br />Analysis</h4>
                            <p>We review material type, thickness, tolerances, and dimensional requirements before initiating cutting operations.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">02</div>
                            <h5 className="process-accent">Machining Process</h5>
                            <h4>Precision Cutting<br />Execution</h4>
                            <p>Using advanced cutting machinery, we perform accurate cutting operations ensuring clean edges and dimensional consistency.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">03</div>
                            <h5 className="process-accent">Quality & Delivery</h5>
                            <h4>Inspection &<br />Delivery</h4>
                            <p>All cut components undergo measurement and quality checks before secure packaging and timely dispatch.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ & Split Section */}
            <section className="mc-faq-section section-padding bg-light pt-0">
                <div className="container">
                    <div className="mc-faq-split">

                        <div className="mc-faq-left">
                            <h5 className="faq-accent">FAQ</h5>
                            <h2 className="section-title text-left">Frequently Asked<br />Questions</h2>
                            <p>Find answers to common questions about our metal cutting services, capabilities, and production process.</p>
                            <button className="btn-primary mt-30" onClick={goToContact}>Request a Quote</button>
                        </div>

                        <div className="mc-faq-right">
                            <div className="mc-faq-grid">
                                {faqs.map((faq, idx) => (
                                    <div
                                        key={idx}
                                        className={`mc-faq-item ${activeFaq === idx ? 'active' : ''}`}
                                        onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                                    >
                                        <div className="mc-faq-header">
                                            <h4>{faq.q}</h4>
                                            <span className="toggle-icon1"></span>
                                        </div>
                                        <div className="mc-faq-body">
                                            <p>{faq.a}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="mc-cta-section">
                <div className="container text-center">
                    <h2>Need Reliable Metal<br />Cutting Services?</h2>
                    <p>Send us your material specifications and required dimensions. Our team will provide a competitive<br />quotation with accurate production timelines.</p>
                    <button className="btn-light mt-30" onClick={goToContact}>Request a Metal Cutting Quote</button>
                </div>
            </section>
        </div>
    );
};

export default MetalCutting;
